import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import apiRequest from "../../../apiCall";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
import toast from "react-hot-toast";

const ProductDetailsForm = ({ autoComplete, onValueChange }) => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;

  const [data, setData] = useState({
    content: "",
  });

  const _data = data;

  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  useEffect(() => {
    if (autoComplete) {
      const secBData = JSON.parse(sessionStorage.getItem("shopApi")).sectionB;
      _data.content = secBData;
      updateData();
    } else {
      _data.content = "";
      updateData();
    }
  }, [autoComplete]);

  const dispatch = useDispatch();
  const handleSave = async () => {
    dispatch(setLoading(true));
    // Create a new FormData object to store the data and image
    const params = {
      itemId: JSON.parse(sessionStorage.getItem("shopApi")).itemId,
      productCode: JSON.parse(sessionStorage.getItem("shopApi")).productCode,
      content: _data.content,
      AdminId: AdminId,
    };
    if (_data.content == "") {
      dispatch(setLoading(false));
      toast.error( "Please fill the content" );
    } else {
      apiRequest("POST", "shop/sectionB", params, true, true).then((res) => {
        dispatch(setLoading(false));
        toast.success( "Data saved successfully" );
        onValueChange(
          JSON.parse(sessionStorage.getItem("shopApi")).productCode
        );
      });
    }
  };
  return (
    <div className="sec" style={{ marginTop: "10vh" }}>
      <h2> Product Details</h2>
      <div className="input-group">
        <label htmlFor="content">Content:</label>
        <ReactQuill
          value={data.content}
          onChange={(value) => setData({ ...data, content: value })}
        />
      </div>

      <button className="save btn" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default ProductDetailsForm;
